import _createForOfIteratorHelper from "@babel/runtime-corejs3/helpers/createForOfIteratorHelper";
import { getEffectTarget } from "@lilib/utils";
import useLatestRef from "./useLatestRef";
import useTargetEffect from "./useTargetEffect";
function useClickOutside(target, listener, options) {
  var targets = Array.isArray(target) ? target : [target];
  var _ref = options || {},
    container = _ref.container,
    _ref$eventName = _ref.eventName,
    eventName = _ref$eventName === void 0 ? "mousedown" : _ref$eventName;
  var eventNames = Array.isArray(eventName) ? eventName : [eventName];
  var listenerRef = useLatestRef(listener);
  useTargetEffect(function () {
    var targetElements = targets.map(getEffectTarget).filter(Boolean);
    if (!targetElements.length) {
      return;
    }
    function handler(event) {
      var _iterator = _createForOfIteratorHelper(targetElements),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var element = _step.value;
          if (element && element.contains(event.target)) {
            return;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      listenerRef.current(event);
    }
    var containerElement = getEffectTarget(container) || document;
    var _iterator2 = _createForOfIteratorHelper(eventNames),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _eventName2 = _step2.value;
        containerElement.addEventListener(_eventName2, handler);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return function () {
      var _iterator3 = _createForOfIteratorHelper(eventNames),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _eventName = _step3.value;
          containerElement.removeEventListener(_eventName, handler);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    };
  }, eventNames, targets);
}
export default useClickOutside;